import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export default function CookieBanner() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const seen = localStorage.getItem("tp-cookie-ack");
      if (!seen) setVisible(true);
    } catch {
      setVisible(true);
    }
  }, []);

  if (!visible) return null;

  const accept = () => {
    try {
      localStorage.setItem("tp-cookie-ack", "accepted");
    } catch {
      /* ignore */
    }
    window.dispatchEvent(new Event("tp-cookie-consent"));
    setVisible(false);
  };

  const decline = () => {
    try {
      localStorage.setItem("tp-cookie-ack", "declined");
    } catch {
      /* ignore */
    }
    window.dispatchEvent(new Event("tp-cookie-consent"));
    setVisible(false);
  };

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:bottom-6 md:max-w-sm z-50 bg-background-100 border border-background-300/40 rounded-xl p-5 backdrop-blur-xl shadow-2xl">
      <h2 className="font-serif-display text-foreground-50 text-lg">
        {t("cookie.title")}
      </h2>
      <p className="mt-2 text-foreground-400 text-sm leading-relaxed">
        {t("cookie.description")}
      </p>
      <div className="flex items-center gap-3 mt-4">
        <button
          type="button"
          onClick={accept}
          className="bg-accent-500 text-black font-label uppercase text-xs tracking-[0.1em] px-5 py-2.5 rounded-full hover:bg-accent-400 transition-all duration-300 cursor-pointer whitespace-nowrap"
        >
          {t("cookie.accept")}
        </button>
        <button
          type="button"
          onClick={decline}
          className="border border-foreground-300/30 text-foreground-400 hover:text-foreground-200 hover:border-foreground-200 font-label uppercase text-xs tracking-[0.1em] px-5 py-2.5 rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap"
        >
          {t("cookie.decline")}
        </button>
      </div>
    </div>
  );
}